<template>
  <div class="row">
    <div class="col-md-12">
      <div class="block">
        <div>
          <a class="float-right"
             href="https://developers.google.com/travel/things-to-do/guides/partner-integration/landing-page-guidelines"
             target="_blank">Google’s landing page requirements</a>
        </div>
        <div>
          <b-tabs content-class="mt-3" no-fade>
            <b-tab title="Deals" active class="nav-item">
              <div id="gttdOfferDeals" class="active col-lg-12" style="min-height: 250px">
                <div class="form-group row">
                  <div class="controls col-lg-12">
              <span class="row mb-2">
                <span class="col col-sm-12">
                  <span class="row mb-2">
                    <span class="col col-sm-12">
                      <item-select
                          :partner-id="partnerId"
                          :venues="[]"
                          :categories="[]"
                          :campaigns="[]"
                          :deals="filteredDeals"
                          filter-type="deal"
                          @added-items="addDeals"
                      ></item-select>
                    </span>
                  </span>
                </span>
              </span>
					  <span>
						  <strong>Important</strong>: When entering your Landing Page URL, please only input the actual landing page address. The system will automatically append the necessary tracking parameters.
					  </span>
                    <span v-if="!deals || !deals.length">
															<h4>No Deals</h4>
														</span>
                    <table v-else id="deal-table" class="table table-sm table-striped">
                      <thead>
                      <tr>
                        <th width="35%">
                          Name
                        </th>
                        <th>
                          Landing page URL
                        </th>
                        <th>
                          Categories
                        </th>

                        <th width="155">
                          Action
                        </th>
                      </tr>
                      </thead>
                      <tbody id="dealListBody" is="draggable" :list="deals" tag="tbody"
                             @change="updateSortOrder('deals')" style="cursor: move;">
                      <tr v-for="(deal, index) in this.selectedDeals">
                        <td style="min-width: 200px">
                          <a :href="`/admin/${partnerId}/deal/${deal.id}`">{{ fullDeal(deal.id)?.name ?? 'd-' }}</a>
                        </td>
                        <td>
                          <div class="input-group">
                            <input id="landing_page_url" name="landing_page_url"
                                   class="form-control" type="text"
                                   v-model="deal.landing_page_url"
                                   @blur="onUrlBlur"/>
                            <span class="invalid-feedback" style="display: block;"
                                  v-if="deal.errors && deal.errors.landing_page_url">{{
                                deal.errors.landing_page_url
                              }}</span>
                          </div>
                        </td>
                        <td>

                          <multiselect
                              @select="onGTTDCategoryChange(deal, 'deal',$event)"
                              v-model="deal.categoryIds"
                              :options="categories.map(opt => opt.label)"
                              :custom-label="getCategoryLabel"
                              :multiple="true"
                              placeholder="Select Categories"
                          >
                          </multiselect>

                        </td>
                        <td>
                          <button type="button" class="btn btn-danger btn-sm removeDeal" @click="removeDeal(deal.id)">
                            Remove
                          </button>
							<button type="button" class="btn btn-primary btn-sm applyCategoriesToAllDeals" @click="applyCategoriesToAllDeals(deal.id)"
								v-if="changedDealId === deal.id"
							>
								Apply to All
							</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </b-tab>
            <b-tab title="Products" class="nav-item">
              <div id="gttdOfferProducts" class=" col-lg-12" style="min-height: 250px">
                <div class="form-group row">
                  <div class="controls col-lg-12">
														<span class="row mb-2">
															<span class="col col-sm-12">
																<span class="row mb-2">
																	<span class="col col-sm-12">
																		<item-select
                                        :partner-id="partnerId"
                                        :venues="[]"
                                        :categories="[]"
                                        :campaigns="[]"
                                        :products="filteredProducts"
                                        filter-type="productSimple"

                                        @added-items="addProducts"
                                    ></item-select>
																	</span>
																</span>
															</span>
														</span>
					  <span>
						  <strong>Important</strong>: When entering your Landing Page URL, please only input the actual landing page address. The system will automatically append the necessary tracking parameters.
					  </span>
                    <span v-if="!products || !products.length">
															<h4>No Products</h4>
														</span>
                    <table v-else id="deal-table" class="table table-sm table-striped">
                      <thead>
                      <tr>
                        <th width="35%">
                          Name
                        </th>
                        <th>
                          Landing page URL
                        </th>
                        <th>
                          Categories
                        </th>

                        <th width="155">
                          Action
                        </th>
                      </tr>
                      </thead>
                      <tbody id="productsListBody" is="draggable" :list="deals" tag="tbody"
                             @change="updateSortOrder('products')" style="cursor: move;">
                      <tr v-for="(product, index) in this.integration.selectedProducts">
                        <td style="min-width: 200px">
                          <a :href="`/admin/${partnerId}/product/${product.id}`">{{ fullProduct(product.id)?.name ?? '-' }}</a>
                        </td>
                        <td>
                          <div class="input-group">
                            <input id="landing_page_url" name="landing_page_url"
                                   class="form-control" type="text"
                                   v-model="product.landing_page_url"
                                   @blur="validateForm"/>
                            <span class="invalid-feedback" style="display: block;"
                                  v-if="product.errors && product.errors.landing_page_url">{{
                                product.errors.landing_page_url
                              }}</span>
                          </div>
                        </td>
                        <td>

                          <multiselect
                              @select="onGTTDCategoryChange(product, 'product',$event)"
                              v-model="product.categoryIds"
                              :options="categories.map(opt => opt.label)"
                              :custom-label="getCategoryLabel"
                              :multiple="true"
                              placeholder="Select Categories"
                          >
                          </multiselect>

                        </td>
                        <td>
                          <button type="button" class="btn btn-danger btn-sm removeProduct"
                                  @click="removeProduct(product.id)">Remove
                          </button>
							<button type="button" class="btn btn-primary btn-sm applyCategoriesToAllProducts" @click="applyCategoriesToAllProducts(product.id)"
									v-if="changedProductId === product.id"
							>
								Apply to All
							</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </b-tab>
          </b-tabs>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    partnerId: {
      type: Number
    },

    deals: {
      type: Array,
      default() {
        return []
      }
    },

    products: {
      type: Array,
      default() {
        return []
      }
    },


    value: {
      type: Object,
      default() {
        return {}
      }
    },

    categories: {
      type: Array,
      default() {
        return []
      }
    },

  },
  data: () => {
    return {
      localValue: null,
		changedProductId: null,
		changedDealId: null,
    }
  },
  computed: {
    integration: {
      get() {
        return this.localValue ?? this.value;
      },
      set(val) {
        this.localValue = val;
        this.$emit('input', val);
      }
    },

    selectedDeals: {
      get() {
        return this.integration.selectedDeals ?? [];
      },
      set(val) {
        this.integration = {...this.integration, selectedDeals: val};
      }
    },

    selectedProducts: {
      get() {
        return this.integration.selectedProducts ?? [];
      },
      set(val) {
        this.integration = {...this.integration, selectedProducts: val};
      }
    },

    validationErrors: {
      get() {
        return this.integration.validationErrors ?? [];
      },
      set(val) {
        this.integration = {...this.integration, validationErrors: val};
      }
    },

    filteredDeals() {
      if (this.selectedDeals.length > 0) {
        let selectedIds = this.selectedDeals.map(v => v.id)
        let deals = this.deals.filter(item => !selectedIds.includes(item.id))
        return deals
      }
      return this.deals
    },

    filteredProducts() {
      if (this.selectedProducts.length > 0) {
        let selectedIds = this.selectedProducts.map(v => v.id)
		return this.products.filter(item => !selectedIds.includes(item.id))
      }
      return this.products

    },

  },

  methods: {
    fullDeal(id){
      return this.deals.find(item => item.id === id)
    },
    fullProduct(id){
      return this.products.find(item => item.id === id)
    },
    onUrlBlur(e) {
      this.validateForm();
    },
	  validateItems: function (selectedItems, errors) {
		  const regex = new RegExp('^https?://', 'i');
		  const utmParams = '?utm_source=Bandwango&utm_medium=GTTD_Organic&utm_campaign=Bandwango_GTTD_Organic';
		  for (let idx in selectedItems) {
			  const item = selectedItems[idx];
			  item.errors = [];
			  this.$set(item, 'errors', {});
			  if (item.landing_page_url && !regex.test(item.landing_page_url)) {
				  this.$set(item.errors, 'landing_page_url', 'Landing page url must start with http:// or https://')
				  errors = [...errors, {id: item.id, error: item.errors}];
			  } else {
				  this.$set(item.errors, 'landing_page_url', '');
			  }
		  }
		  return errors;
	  },
	  validateForm() {
		  let errors = [];
		  errors = this.validateItems(this.selectedDeals, errors);
		  errors = this.validateItems(this.selectedProducts, errors);
		  this.validationErrors = errors;
    },

    getCategoryLabel(opt) {
      const category = this.categories.find(category => category.label === opt);
      return category ? category?.name ?? 'c' : '';
    },
    onGTTDCategoryChange(item, type, key) {
      const selected = key;
      const category = this.categories.find(category => category.label === selected);
      if (category && category['exclusive-with']) {
        const toExclude = category['exclusive-with'];
        const idx = item.categoryIds.findIndex(id => id === toExclude);
        if (idx > -1) {
          item.categoryIds.splice(idx, 1);
        }
      }
	  if(type === 'deal') {
		  this.changedDealId = item.id;
	  } else {
		  this.changedProductId = item.id;	
	  }
	},


    addDeals(dealIds) {
      let selectedDeal = this.deals.filter(deal => {
        return dealIds.some(id => id === deal.id)
      })

      selectedDeal.forEach(deal => {
        let newDeal = {
          'id': deal.id,
          'categoryIds': [],
          'landing_page_url': deal.landing_page_url,
        };
        this.selectedDeals = [...this.selectedDeals, newDeal];
      })
    },
    removeDeal(dealId) {
      let idx = this.selectedDeals.findIndex(deal => deal.id === dealId);
      this.selectedDeals.splice(idx, 1);
      this.changedDeallId = dealId;
    },
	  applyCategoriesToAllDeals(dealId) {
		  const selectedDeal = this.selectedDeals.find(deal => deal.id === dealId);
		  this.selectedDeals.forEach(deal => {
			  if (deal.id !== dealId) {
				  deal.categoryIds = [...selectedDeal.categoryIds];
			  }
		  });
		  this.changedDeallId = null;
	  },

    addProducts(productIds) {
      let selectedProduct = this.products.filter(product => {
        return productIds.some(id => id === product.id)
      })

      if (!this.selectedProducts) {
        this.selectedProducts = [];
      }

      selectedProduct.forEach(product => {
        let newProduct = {
          'id': product.id,
          'categoryIds': [],
          'landing_page_url': product.landing_page_url,
        };
        this.selectedProducts = [...this.selectedProducts, newProduct];
      })
    },
    removeProduct(productId) {
      let idx = this.selectedProducts.findIndex(product => product.id === productId);
      this.selectedProducts.splice(idx, 1);
      this.changedProductlId = productId;
    },
	  applyCategoriesToAllProducts(productId) {
		  const selectedProduct = this.selectedProducts.find(product => product.id === productId);
		  this.selectedProducts.forEach(product => {
			  if (product.id !== productId) {
				  product.categoryIds = [...selectedProduct.categoryIds];
			  }
		  });
		  this.changedProductId = null;
	  },
	updateSortOrder(type) {
	  let items = this.selectedDeals;
	  if (type === 'products') {
		items = this.selectedProducts;
	  }
	  items.forEach((item, index) => {
		item.sort_order = index + 1;
	  });
	},

  },

}
</script>